/**
 * Cache strategy for variable collection.
 * Controls how often a variable is re-collected.
 */
export enum CacheStrategy {
  /** Re-collect every 10 seconds */
  FAST = 10_000,
  /** Re-collect every 1 minute */
  MEDIUM = 60_000,
  /** Re-collect every 5 minutes */
  SLOW = 300_000,
  /** Collect once per session (never expires while SDK is alive) */
  HEAVY = 9007199254740991,
}

export interface VariableCollectionMetadata {
  strategy: CacheStrategy;
  lastCollected?: number;
}
